import { Component } from '@angular/core';
import {PasswordUpdaterComponent} from "@components";

@Component({
  selector: 'wun-credentials',
  standalone: true,
  imports: [
    PasswordUpdaterComponent
  ],
  templateUrl: './credentials.component.html',
  styleUrl: './credentials.component.scss'
})
export class CredentialsComponent {

}
